"use client";

import React from "react";
import TopComponent from "./topcomponent/top";
import CareerLookSection from "./CareerLookSection";
import BuildCareerSection from "./BuildCareerSection";
import RecentOpeningsSection from "./RecentOpeningsSection";

const CareerComponent = ({ vacancyList }) => {
  return (
    <div>
      <TopComponent />
      <BuildCareerSection />
      <CareerLookSection />
      <RecentOpeningsSection vacancyList={vacancyList} />
    </div>
  );
};

export default CareerComponent;
